module.exports = __webpack_public_path__ + "img/download.1e74db94.svg";